import {
    AfterViewInit,
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { takeWhile } from 'rxjs/operators';
import { SelectItem } from '../../../shared';

@Component({
    selector: 'ef-invoice-setup-filters-presenter',
    templateUrl: './invoice-setup-filters-presenter.component.html',
    styleUrls: ['./invoice-setup-filters-presenter.component.scss'],
    standalone: false
})
export class InvoiceSetupFiltersPresenterComponent
    implements OnInit, AfterViewInit, OnDestroy {
    private _contracts: SelectItem[];
    @Input() public set contracts(value: SelectItem[]) {
        this._contracts = value;
        // if (value && value.length > 0) {
        //     this.filterFormGroup.controls['Contracts'].setValue([value[0].value]);
        // }
    }
    public get contracts(): SelectItem[] {
        return this._contracts;
    }
    @Output() SelectContract = new EventEmitter<string>();
    filterFormGroup: UntypedFormGroup;
    private active = true;
    constructor() {
        this.filterFormGroup = new UntypedFormGroup({
            Contracts: new UntypedFormControl(null)
        });
    }

    ngOnInit(): void {
        this.filterFormGroup.controls['Contracts'].valueChanges
            .pipe(takeWhile(() => this.active))
            .subscribe(value => this.SelectContract.next(value));
    }
    ngAfterViewInit(): void {}
    ngOnDestroy(): void {
        this.active = false;
    }
}
